import { render, staticRenderFns } from "./BaseColorInput.vue?vue&type=template&id=6be531fe&scoped=true"
import script from "./BaseColorInput.vue?vue&type=script&lang=js"
export * from "./BaseColorInput.vue?vue&type=script&lang=js"
import style0 from "./BaseColorInput.vue?vue&type=style&index=0&id=6be531fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be531fe",
  null
  
)

export default component.exports